module.exports = "/packs/images/homepage/facilities/lifeguard~45afd0cf2cb0ac52a2bcabe5d6230c9a.png";